if (!customElements.get('product-box-contents-accordion')) {
  class ProductBoxContentsAccordion extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.trigger = this.querySelector('[data-product-box-contents-trigger]');
      this.panel = this.querySelector('[data-product-box-contents-panel]');
      this.inner = this.querySelector('[data-product-box-contents-inner]');

      if (!(this.panel instanceof HTMLElement) || !(this.inner instanceof HTMLElement)) return;

      if (!(this.trigger instanceof HTMLElement)) {
        this.classList.add('is-open');
        this.panel.style.height = 'auto';
        this.panel.removeAttribute('aria-hidden');
        return;
      }

      this.onClick = this.toggle.bind(this);
      this.onResize = this.syncOpenHeight.bind(this);

      if (this.classList.contains('is-open') || this.dataset.openDefault === 'true') {
        this.open(false);
      } else {
        this.close(false);
      }

      this.trigger.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      if (this.trigger instanceof HTMLElement && this.onClick) {
        this.trigger.removeEventListener('click', this.onClick);
      }

      if (this.onResize) {
        window.removeEventListener('resize', this.onResize);
      }
    }

    toggle() {
      if (this.classList.contains('is-open')) {
        this.close();
      } else {
        this.open();
      }
    }

    syncOpenHeight() {
      if (!this.classList.contains('is-open')) return;

      this.panel.style.height = `${this.inner.offsetHeight}px`;
      requestAnimationFrame(() => {
        if (this.classList.contains('is-open')) {
          this.panel.style.height = 'auto';
        }
      });
    }

    open(animate = true) {
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.panel.removeAttribute('aria-hidden');

      if (!animate) {
        this.panel.style.height = 'auto';
        return;
      }

      const startHeight = this.panel.offsetHeight;
      const endHeight = this.inner.offsetHeight;

      this.panel.style.height = `${startHeight}px`;
      requestAnimationFrame(() => {
        this.panel.style.height = `${endHeight}px`;
      });

      this.panel.addEventListener(
        'transitionend',
        () => {
          if (this.classList.contains('is-open')) {
            this.panel.style.height = 'auto';
          }
        },
        { once: true }
      );
    }

    close(animate = true) {
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.panel.setAttribute('aria-hidden', 'true');

      if (!animate) {
        this.panel.style.height = '0px';
        return;
      }

      const startHeight = this.panel.style.height === 'auto' ? this.inner.offsetHeight : this.panel.offsetHeight;

      this.panel.style.height = `${startHeight}px`;
      requestAnimationFrame(() => {
        this.panel.style.height = '0px';
      });
    }
  }

  customElements.define('product-box-contents-accordion', ProductBoxContentsAccordion);
}
